import React from 'react';
import { ComponentActionHandler } from './actionHandler';
import { Adaptor } from './adaptor';
import { onComponentEventAction } from '../shared/componentEventActionEmitter';
import { emitCustomEvent } from '../shared/customEventTrigger';
import { emitPage, PageEventListenerTypes } from '../shared/eventListener';
import { PositionHandler } from './PositionHandler';
import { generatePluginParams } from '../shared/actionParams';

if (typeof window === 'undefined') {
  // 兼容 ssr 时，window 为 undefined 导致报错的情况
  global.window = {};
}

function ComponentItem({ meta, global, instance, ...injectProps }) {
  const {
    key,
    children,
    component: { component: Component },
    data,
    style,
    commonStyle,
    position,
    slot,
  } = instance;

  const emit = (trigger, payload) => emitCustomEvent(instance, trigger, global, meta, payload);

  const on = (eventName, callback) => onComponentEventAction(instance, eventName, callback);

  if (children) {
    const content = (
      <Component
        key={key}
        componentKey={key}
        data={data}
        meta={meta}
        global={global}
        style={style}
        commonStyle={commonStyle}
        emit={emit}
        on={on}
        slot={slot}
      >
        {children.map((childInstance) => (
          <ComponentItem
            key={childInstance.key}
            instance={childInstance}
            meta={meta}
            global={global}
            slot={childInstance.slot}
          />
        ))}
      </Component>
    );

    return (
      <ComponentActionHandler instance={instance} meta={meta} global={global}>
        {position ? (
          <PositionHandler positionStyle={position} instance={instance}>
            {content}
          </PositionHandler>
        ) : (
          content
        )}
      </ComponentActionHandler>
    );
  }

  const content = (
    <ComponentActionHandler instance={instance} meta={meta} global={global}>
      <Adaptor instance={instance} injectProps={injectProps} meta={meta} global={global} />
    </ComponentActionHandler>
  );

  if (position) {
    return (
      <PositionHandler positionStyle={position} instance={instance}>
        {content}
      </PositionHandler>
    );
  }

  return content;
}

export function AppRender({ componentInstances, pluginInstances, global, meta }) {
  const execPlugins = React.useCallback(() => {
    pluginInstances.forEach((plugin) => {
      const {
        plugin: { plugin: pluginFn },
      } = plugin;
      const params = generatePluginParams(plugin, global, meta);
      pluginFn(params);
    });
  }, []);

  React.useEffect(() => {
    execPlugins();
    emitPage(PageEventListenerTypes.INIT, { global, meta });
  }, []);

  return (
    <>
      {componentInstances.map((instance) => (
        <ComponentItem key={instance.key} instance={instance} meta={meta} global={global} />
      ))}
    </>
  );
}
